export const getVirImages = (virId: string) => {
  return {
    url: `${process.env.REACT_APP_ORIGIN}/images/vir/${virId}`,
    method: 'GET',
  }
}
